<script>
export default {};
</script>

<template>
	<footer>
		<div class="footer-wrapper">
			<div class="brand-text pc">
				<div class="brand">
					<span class="text_ch_medium">© </span>
					<span class="BMW-words text_en_regular">BMW </span>
					<span class="text_ch_medium">總代理 汎德股份有限公司</span>
				</div>
			</div>
			<div class="marketing-text">
				<div class="sns mobile">
					<a
						class="facebook mobile"
						href="https://www.facebook.com/BMWTaiwanOfficial/"
						target="_blank"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'footer',
							event_label: 'FB',
						}"
					>
					</a>
					<a
						class="instagram mobile"
						href="https://www.instagram.com/bmwtaiwan/"
						target="_blank"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'footer',
							event_label: 'IG',
						}"
					>
					</a>
					<a
						class="line mobile"
						href="https://page.line.me/bmwtaiwan"
						target="_blank"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'footer',
							event_label: 'LINE',
						}"
					>
					</a>
					<a
						class="youtube mobile"
						href="https://www.youtube.com/user/BMWTWOFFCIAL"
						target="_blank"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'footer',
							event_label: 'youtube',
						}"
					>
					</a>
				</div>
				<a
					class="site"
					href="https://www.bmw.com.tw/zh/index.html"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'footer',
						event_label: 'official_website',
					}"
				>
					<span class="BMW-words text_en_regular">BMW TAIWAN</span>
					<span class="text_ch_medium">官網</span>
				</a>
				<a
					class="branch"
					href="https://www.bmw.com.tw/zh/owner/overview.html"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'footer',
						event_label: 'Showroom',
					}"
				>
					<span class="BMW-words text_en_regular">BMW</span>
					<span class="text_ch_medium">全台展示中心</span>
				</a>
				<a
					class="claim"
					href="https://www.bmw.com.tw/zh/footer/metanavigation/legal-disclaimer-pool/legal-disclaimer.html"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'footer',
						event_label: 'legal_disclaimer',
					}"
				>
					<span class="text_ch_medium">網站聲明</span>
				</a>
				<a
					class="facebook pc"
					href="https://www.facebook.com/BMWTaiwanOfficial/"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'footer',
						event_label: 'FB',
					}"
				>
				</a>
				<a
					class="instagram pc"
					href="https://www.instagram.com/bmwtaiwan/"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'footer',
						event_label: 'IG',
					}"
				>
				</a>
				<a
					class="line pc"
					href="https://page.line.me/bmwtaiwan"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'footer',
						event_label: 'LINE',
					}"
				>
				</a>
				<a
					class="youtube pc"
					href="https://www.youtube.com/user/BMWTWOFFCIAL"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'footer',
						event_label: 'YouTube',
					}"
				>
				</a>
			</div>
		</div>
		<div class="brand-text mobile">
			<div class="brand">
				<span class="text_ch_medium">© </span>
				<span class="BMW-words text_en_regular">BMW </span>
				<span class="text_ch_medium">總代理 汎德股份有限公司</span>
			</div>
		</div>
		<div class="sep-line"></div>
		<div class="bg mobile"></div>
	</footer>
</template>

<style lang="sass" scoped>
footer
    position: relative
    width: 100%
    height: 80px
    padding-bottom: 35px
    background-color: rgba(#111, 0.95)
    z-index: 500

.footer-wrapper
    width: 90%
    height: 100%
    margin: 0 auto
    display: flex
    justify-content: space-between
    align-items: flex-end
    border-bottom: solid 1px rgba(#fff, 0.2)
    .brand-text, .marketing-text
        margin-bottom: 19.5px
    .mobile
        display: none
    a, .brand-text
        user-select: none
        cursor: pointer
        text-decoration: none
        margin-left: 2.3rem
        vertical-align: middle
        &.brand
            margin-left: 0px
        span
            font-size: 1.5rem
            letter-spacing: 0.38px
            color: #ddd
        .BMW-words
            font-size: 1.3rem
            letter-spacing: 1.17px
    .facebook
        display: inline-block
        width: 10.4px
        height: 19.7px
        // object-fit: cover
        background-image: url("~@/assets/FB.png")
        background-size: cover
        background-position: center
        background-repeat: no-repeat
    .instagram
        display: inline-block
        width: 19.7px
        height: 19.7px
        // object-fit: cover
        background-image: url("~@/assets/instagram.png")
        background-size: cover
        background-position: center
        background-repeat: no-repeat
    .line
        display: inline-block
        width: 19.7px
        height: 19.7px
        // object-fit: cover
        background-image: url("~@/assets/line.png")
        background-size: cover
        background-position: center
        background-repeat: no-repeat
    .youtube
        display: inline-block
        width: 19.7px
        height: 19.7px
        // object-fit: cover
        background-image: url("~@/assets/youtube.png")
        background-size: cover
        background-position: center
        background-repeat: no-repeat
    .brand-text
        cursor: auto

// @media screen and (max-width: 768px)
//     footer
//         .footer-wrapper
//             a, .brand-text
//                 margin-left: 1.5rem
//                 span
//                     font-size: 1.2rem
//                     letter-spacing: 0.3px
//                     &.BMW-words
//                         font-size: 1.2rem
//                         letter-spacing: 0.6px
@media screen and (max-width: 768px)
    footer
        height: auto
        background-image: url("~@/assets/footer_background.jpg")
        background-blend-mode: multiply
        background-size: cover
        background-position: center top
        background-repeat: no-repeat
        .sep-line
            position: absolute
            width: calc(85% - 15px)
            height: 1px
            left: calc(7.5% + 10px)
            top: 80px
            background-color: #333
        .footer-wrapper
            padding-top: 45px
            width: 85%
            border: none
            .pc
                display: none
            .marketing-text
                display: flex
                flex-direction: column
                justify-content: center
                align-items: flex-start
                margin-bottom: 10px
                padding-left: 15px
                .sns
                    .facebook, .instagram, .line, .youtube
                        display: inline-block
                        margin-left: 6.5vw
                        margin-bottom: 45px
                    .facebook
                        margin-left: 0
                .pc
                    display: none
                .mobile
                    display: block
                a
                    display: block
                    margin-left: 0
                    margin-bottom: 25px
                    span
                        font-size: 1.2rem
                        letter-spacing: 0.3px
                        &.BMW-words
                            font-size: 1.2rem
                            letter-spacing: 0.6px
        .brand-text
            position: relative
            width: calc(85% - 20px)
            margin: 15px auto
            text-align: left
            z-index: 10
            .brand
                user-select: none
                cursor: pointer
                text-decoration: none
                span
                    font-size: 1rem
                    letter-spacing: 0.25px
                    color: #999
                    &.BMW-words
                        font-size: 1rem
                        letter-spacing: 0.5px
        .bg
            position: absolute
            width: 100%
            height: 100px
            bottom: 0
            z-index: 1
            background-image: url("~@/assets/inc.png")
</style>
